import { defineStore } from 'pinia'
import { computed } from 'vue'
import AppConfig from '@/config'

const usePrivateDevStore = defineStore('private-dev', () => {
	const currentModel: String = AppConfig.modelName
	return { currentModel }
})

export const useDevStore = defineStore('dev', () => {
	const privateDev = usePrivateDevStore()
	async function setModel(newModel: string) {
		if (AppConfig.devSetting) {
			privateDev.currentModel = newModel
		}
	}

	function resetModel() {
		privateDev.currentModel = AppConfig.modelName
	}

	return {
		currentModel: computed(() => privateDev.currentModel),
		resetModel,
		setModel
	}
})
